import React, { useEffect, useState } from 'react';
import { signOut, onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import {auth} from './../firebase';

export const Dashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  // Verificar si el usuario es el administrador autorizado
  const isAuthorizedAdmin = user?.email === 'raulizqli@gmail.com';

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login'); // Redirect to login page after logout
    } catch (error) {
      console.error("Error logging out:", error.message);
      alert(error.message);
    }
  };

  const handleStudents = async () => {
    navigate('/students');
  };

  const handleGroupPhotos = async () => {
    navigate('/group-photos');
  };

  const handleBlogs = async () => {
    navigate('/blogs');
  };

  const handleEvents = async () => {
    navigate('/events');
  };

  const handleProjectTypes = async () => {
    navigate('/project-types');
  };

  const handlePapers = async () => {
    navigate('/papers');
  };

  const handlePatents = async () => {
    navigate('/patents');
  };

  const handleProfile = async () => {
    navigate('/profile');
  };

  const handleCollaborators = async () => {
    navigate('/collaborators');
  };

  const handleTesis = async () => {
    navigate('/tesis');
  };

  const handleTesisTypes = async () => {
    navigate('/tesis-types');
  };

  const handleTesisCategories = async () => {
    navigate('/tesis-categories');
  };

  const handleResearchLines = async () => {
    navigate('/research-lines');
  };

  const handleSubLines = async () => {
    navigate('/sub-lines');
  };

  const handleMigrateResearchLines = async () => {
    navigate('/migrate-research-lines');
  };

  return (
    <div className="container-fluid mt-1">
        <div className="card shadow">
            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Panel de Control</h3>
            </div>
            <div className="card-body">
              <button className="btn btn-primary" onClick={handleStudents}>Listado de Alumnos</button>
              &nbsp;
              <button className="btn btn-primary" onClick={handleGroupPhotos}>Listado de Fotos Grupales</button>
              &nbsp;
              <button className="btn btn-primary" onClick={handleBlogs}>Listado de Blogs</button>
              &nbsp;
              <button className="btn btn-primary" onClick={handleEvents}>Listado de Eventos</button>
              &nbsp;
              <button className="btn btn-primary" onClick={handleTesis}>Listado de Tesis</button>
              &nbsp;
              <button className="btn btn-primary" onClick={handlePapers}>Listado de Publicaciones</button>
              <hr/>
              <button className="btn btn-primary" onClick={handlePatents}>Listado de Patentes</button>
              &nbsp;
              <button className="btn btn-primary" onClick={handleCollaborators}>Listado de Colaboradores</button>
              &nbsp;
              <button className="btn btn-primary" onClick={handleProjectTypes}>Listado de Tipos de Proyectos</button>
              &nbsp;
              <button className="btn btn-primary" onClick={handleTesisTypes}>Listado de Tipos de Tesis</button>
              &nbsp;
              <button className="btn btn-primary" onClick={handleTesisCategories}>Listado de Categorias de Tesis</button>
              <hr/>
              <button className="btn btn-primary" onClick={handleProfile}>Editar Información Principal</button>
              &nbsp;
              <button className="btn btn-primary" onClick={handleResearchLines}>Listado de Líneas de Investigación</button>
              &nbsp;
              <button className="btn btn-primary" onClick={handleSubLines}>Listado de Sub-líneas de Investigación</button>
              {isAuthorizedAdmin && (
                <>
                  &nbsp;
                  <button className="btn btn-warning" onClick={handleMigrateResearchLines}>Migrar Líneas de Investigación</button>
                </>
              )}
          </div>
        </div>
        <div className="card">
            <div className="card-body">
                <button className="btn btn-primary w-100" onClick={handleLogout}>Salir</button>
            </div>
        </div>
    </div>
  );
}
